import { isFunction, isUndefined } from 'lodash';

export default (...args: any[]) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const initialState = !isFunction(args.at(-1)) && args.pop();
  const reducers = args;

  if (isUndefined(initialState)) {
    throw new TypeError(
      'The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.'
    );
  }

  return (prevState: any, value: any, ...args: any[]) => {
    const prevStateIsUndefined = isUndefined(prevState);
    const valueIsUndefined = isUndefined(value);

    if (prevStateIsUndefined && valueIsUndefined && initialState) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return initialState;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return reducers.reduce(
      (newState, reducer, index) => {
        if (isUndefined(reducer)) {
          throw new TypeError(
            `An undefined reducer was passed in at index ${index}`
          );
        }

        // TODO: Fix types here
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
        return reducer(newState, value, ...args);
      },
      prevStateIsUndefined && !valueIsUndefined && initialState
        ? initialState
        : prevState
    );
  };
};
